import { Business, BusinessInformation } from './business';

export const buildBusiness = (business: any): Business => {
  return {
    title: business.title,
    timezone: business.timezone,
    url: business.url,
    id: business.id,
    meta: business.meta,
    billingVersion: +business.billingVersion,
    billingProvider: business.billingProvider,
    onboardingFlow: business.onboardingFlow,
    recommendedPlan: business.recommendedPlan,
    trialResetPending: !!business.trialResetPending,
    registrationSource: business.registrationSource,
    hasCommerceApp: !!business.hasCommerceApp,
    commerceShopDomain: business.commerceShopDomain,
    information: buildBusinessInformation(business.information),
    faqLimit: +business.faqLimit || 20,
    transferCallsLimit: +business.transferCallsLimit || 20,
    textALinkLimit: +business.textALinkLimit || 20,
    scenarioLimit: business.scenarioLimit,
    crmContactLimit: business.crmContactLimit || null,
    disconnectedIntegrations: business.disconnectedIntegrations || [],
  };
};

export const buildBusinessInformation = (businessInfo: any): BusinessInformation => {
  return {
    description: businessInfo.description,
    urls: businessInfo.urls || [],
    notificationCallTypes: businessInfo.notificationCallTypes || [],
    googleMapsUrl: businessInfo.googleMapsUrl || '',
    phone: businessInfo.phone,
    additionalProperties: businessInfo.additionalProperties,
    meta: businessInfo.meta,
    id: businessInfo.id,
  };
};
